"use client";

import { useEffect } from "react";

/**
 * Start the main app chunk during the logo, in parallel with sign-in.
 * The second open then reads that file from the phone cache instead of
 * waiting to discover it after the account query returns.
 */
export function PreloadStudioShell() {
  useEffect(() => {
    void import("@/studio/components/StudioShell");
  }, []);
  return null;
}
